import './SearchBox.scss';

import React, { forwardRef, useContext, useState } from 'react'
import { useFormContext } from 'react-hook-form';
import { get } from 'lodash';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import FormLabel from 'react-bootstrap/FormLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Image from 'react-bootstrap/Image';

import ClipLoader from 'react-spinners/ClipLoader';

import { NCRContext } from 'views';

const SearchBox = forwardRef(({ label, name, disabled, placeholder, getSalesOrder, setSODetails, loading }, ref) => {

  const { state } = useContext(NCRContext);
  const { errors } = useFormContext();

  const defaultValue = get(state, name) || '';
  const defaultError = get(errors, name);

  const [SONumber, setSONumber] = useState(defaultValue);

  const onChange = (event) => setSONumber(event.target.value);
  const onKeyPress = (event) => event.key === 'Enter' && getSalesOrder(SONumber);

  const clearSoDetails = () => setSODetails(null);

  return (
    <>
      <Row className={'mb-2'}>
        <Col className={'my-auto'}>
          <FormLabel className={'my-auto'}>{`${label}:`}</FormLabel>
        </Col>
        <Col>
          {
            defaultValue
              ?
              disabled
                ?
                <FormControl
                  disabled
                  defaultValue={defaultValue}
                  name={name}
                />
                :
                <InputGroup>
                  <FormControl disabled defaultValue={defaultValue} />
                  <InputGroup.Append>
                    <div id='exit-search' className='btn btn-danger' onClick={() => clearSoDetails()} >
                      <Image src={`${process.env.PUBLIC_URL}/images/cross.png`} width='16' height='16' />
                    </div>
                  </InputGroup.Append>
                </InputGroup>
              :
              <InputGroup>
                <FormControl
                  onChange={onChange}
                  onKeyPress={onKeyPress}
                  disabled={disabled}
                  defaultValue={defaultValue}
                  name={name}
                  ref={ref}
                  placeholder={placeholder}
                  className={
                    (defaultError && !defaultValue ? 'error ' : '') +
                    (disabled ? 'read-only ' : 'general-input ')
                  }
                />
                <InputGroup.Append>
                  {
                    loading
                      ?
                      <InputGroup.Text>
                        <ClipLoader size={16} color='grey' />
                      </InputGroup.Text>
                      :
                      <InputGroup.Text disabled={disabled} onClick={() => getSalesOrder(SONumber)} role={disabled ? 'disabled' : 'button'} >
                        <Image src={`${process.env.PUBLIC_URL}/images/search_icon.png`} width='16' height='16' />
                      </InputGroup.Text>
                  }
                </InputGroup.Append>
              </InputGroup>
          }
        </Col>
      </Row>
    </>
  )
})

export { SearchBox };
